import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PurchaseMethodModal from 'sites/views/purchase-method-modal';
import LimitModal from 'sites/views/wallet-tip-modules/limit-modal';
import { getWalletBalance, paymentPurchaseUsingWallet, oneClickPurchase } from 'sites/api/AuthApi';
import {
   setModalState,
} from 'sites/state/modules/tip/actions';
import {
   updateMediaItem as updateMediaItemInHompageAction,
} from 'sites/state/modules/homepage/actions';
import {
   updateRecordoByIdAction,
} from 'sites/state/modules/livestream/actions';
import {
   getWalletBalanceOperation,
} from 'sites/state/modules/common/operations';
import {
   updateWalletBalanceStart,
   updateWalletBalanc,
   updateWalletBalanceFailed,
} from 'sites/state/modules/common/actions';
import {
   authUserSelector,
   siteInfoSelector,
   screenWidthSelector,
   walletBalanceSelector,
   isFetchingBalanceSelector,
   walletMediaDataSelector,
   isFakeUserSelector,
} from 'sites/state/modules/common/selectors';
import { paymentSend } from 'sites/state/modules/purchase-send/operations';
import {
   setSendModalState,
   sendRequest,
   sendCompleted,
   sendFailed,
   setUpdateMethods,
} from 'sites/state/modules/purchase-send/actions';
import { initWalletOperation, initWalletPaymentHistoryOperation } from 'sites/state/modules/wallet/operations';

import { isFetchingSelector } from 'sites/state/modules/wallet/selectors';
import {
   isNotEnoughtBalanceSelector,
   isSendSelector,
   isFetchingSendSelector,
   isOpenSendModalSelector,
   isOpenChoosePaymentModalSelector,
   modalTypeSelector,
   modalKeySelector,
   methodsSelector,
   oneClickInfoSelector,
   paymentErrorSelector,
   onlyWalletPaySelector,
   contentDataSelector,
   purchaseDataSelector,
   isFetchingModalSelector,
   pageTypeSelector,
} from 'sites/state/modules/purchase-send/selectors';
import {
   isFetchingJoinSelector,
} from 'sites/state/modules/purchase/selectors';
import {
   downloadMediaOperation,
} from 'sites/state/modules/media-resources/operations';
import {
   initLiveStreamOperation, updateRecordsDataAfterPurchaseOperation,
} from 'sites/state/modules/livestream/operations';
import {
   tipModalDataSelector,
   isCheckLimitFetchingSelector,
} from 'sites/state/modules/tip/selectors';
import { purchaseOptions } from 'sites/state/modules/purchase/operations';
import PageLoader from 'common/components/modules/page-loading';
import Router from 'sites/routes/router';
import { push } from 'connected-react-router';
import QueryParams from 'sites/utils/QueryParams';
import toast from 'common/utils/toast';
import { currentLocationPathSelector } from 'sites/state/modules/router/selectors';

import {
   fetchPhotosetByIdCompleted,
   updatePhotosetById,
} from 'sites/state/modules/photosets/actions';
import {
   fetchVideoByIdCompleted,
   updateVideoById,
} from 'sites/state/modules/videos/actions';
import {
   setUpdatePurchaseMeda,
} from 'sites/state/modules/common/actions';
import {
   getPhotosetById,
   getVideoById,
   initLiveStream,
}  from 'sites/api/MixApi';
import {
   getChatUnlcokedItem,
   getWalletBalance as getWalletBalanceApi,
}  from 'sites/api/AuthApi';
import { chatPanelSelector } from 'sites/state/modules/chat/selectors';
import { updatePhotosetDataAfterPurchaseOperation } from 'sites/state/modules/photosets/operations';
import { updateVideoDataAfterPurchaseOperation } from 'sites/state/modules/videos/operations';
import { addDynamicCode, onUnavailableLivestreamPurchase, sendGoogleAnalyticsPurchaseEvent } from 'common/utils/utils';
import { initStoreByIdOperation } from 'sites/state/modules/store/operations';
import Modal from 'common/components/modules/modal';
import SocialMediaLinks from 'sites/views/social-media-links';
import { onChangeFavoriteItemOperation } from 'sites/state/modules/my-favorites/operations';
// import LocalStorage from 'sites/utils/LocalStorage';
class PurchaseTipContaine extends Component {

   static propTypes = {
      onCloseSendModal: PropTypes.func,
      initWallet: PropTypes.func,
      setModalState: PropTypes.func,
      authUser: PropTypes.object,
      siteInfo: PropTypes.object,
      screenWidth: PropTypes.number,
      id: PropTypes.any,
      isFetching: PropTypes.bool,
      isSend: PropTypes.bool,
      isFetchingSend: PropTypes.bool,
      isNotEnoughtBalance: PropTypes.bool,
      isGoBack: PropTypes.bool,
      type: PropTypes.string,
      onDownload: PropTypes.func,
      usdTerms: PropTypes.any,
      goTo: PropTypes.func,
      setSendModalState: PropTypes.func,
      isFetchingJoin: PropTypes.bool,
      // onClickPayment: PropTypes.func,
      isOpenChoosePaymentModal: PropTypes.bool,
      modalType: PropTypes.string,
      walletBalance: PropTypes.number,
      isFetchingBalance: PropTypes.bool,
      updateWalletBalanceStart: PropTypes.func,
      updateWalletBalanc: PropTypes.func,
      updateWalletBalanceFailed: PropTypes.func,
      getWalletBalance: PropTypes.func,
      sendRequest: PropTypes.func,
      sendCompleted: PropTypes.func,
      sendFailed: PropTypes.func,
      initWalletPaymentHistory: PropTypes.func,
      fetchPhotosetByIdCompleted: PropTypes.func,
      mediaName: PropTypes.string,
      closeChat: PropTypes.func,
      isCheckLimitFetching: PropTypes.bool,
      tipModalData: PropTypes.object,
      mediaData: PropTypes.object,
      locationPath: PropTypes.string,
      updateMassMessageAfterPayment: PropTypes.func,
      methods: PropTypes.object,
      isAddProcessingFees: PropTypes.bool,
      paymentType: PropTypes.string,
      isFakeUser: PropTypes.bool,
      referrerUrl: PropTypes.object,
      oneClickInfo: PropTypes.object,
      setUpdatePurchaseMeda: PropTypes.func,
      updatePhotosetById: PropTypes.func,
      fetchVideoByIdCompleted: PropTypes.func,
      updateVideoById: PropTypes.func,
      unlockType: PropTypes.string,
      paymentError: PropTypes.object,
      extraInfo: PropTypes.object,
      updateMediaItem: PropTypes.func,
      initLiveStream: PropTypes.func,
      onlyWalletPay: PropTypes.bool,
      paymentSend: PropTypes.func,
      contentData: PropTypes.object,
      chatPanel: PropTypes.object,
      videoType: PropTypes.string,
      updateRecordoById: PropTypes.func,
      actionAfterPayment: PropTypes.func,
      updatePhotosetDataAfterPurchase: PropTypes.func,
      updateVideoDataAfterPurchase: PropTypes.func,
      updateRecordsDataAfterPurchase: PropTypes.func,
      purchaseData: PropTypes.object,
      onCloseSuccessModal: PropTypes.func,
      fetchStoreById: PropTypes.func,
      updateCallBackAfterRedirectPayment: PropTypes.func,
      isFetchingModal: PropTypes.bool,
      openChargeModal: PropTypes.bool,
      pageType: PropTypes.any,
      onChangeFavoriteItem: PropTypes.func,
      isChat: PropTypes.bool,
   };

   constructor(props) {
      super(props);
      this.state = {
         animateSend: 'up',
         animateLimit: 'up',
         height: 0,
         isSendTip: false,
         showLinks: false,
         shareableItemId: null,
         shareableItemType: null,
      }
      this.id = this.props.id;
      this.type = this.props.type;
   }

   componentDidMount(){
      this.setState({ height: window.innerHeight })
   }


   clearModalState = () => {
      const { setSendModalState } = this.props;
      const initial = {
         isFetching: false,
         isOpenSendModal: false,
         isSend: false,
         isNotEnoughtBalance: false,
         isOpenChoosePaymentModal: false,
         savedPaymentData: {
            isSaved: false,
            payment_method: null,
            id: null,
            payment_system: null,
            type: null,
         },
         price: null,
         methods: {},
         paymentButtonLoading: false,
         oneClickInfo: {},
      }
      setSendModalState(initial);
   }

   componentWillUnmount() {
      this.clearModalState();
   }


   goBack = () => {
      const { setModalState, onCloseSendModal, screenWidth } = this.props;
      if(screenWidth < 701) {
         this.setState({ animateSend: 'down' });
         this.timerFetching = setTimeout(() => {
            onCloseSendModal(false);
            setTimeout(() => {
               setModalState({ 'isTipModal': true });
            }, 100)
         }, 800)
      } else {
         onCloseSendModal(false);
         setTimeout(() => {
            setModalState({ 'isTipModal': true });
         }, 100)
      }
   }

   onCloseSendModal = (bool, isTip) => {
      if(isTip){
         const data = { isTipModal: false }
         QueryParams.removeQueryParam('open-top-up');
         QueryParams.removeQueryParam('modal-key');
         const { setModalState, setSendModalState, screenWidth } = this.props;
         this.setState({ animateTip: 'down' });
         if(screenWidth < 701) {
            this.timerFetching = setTimeout(() => {
               setSendModalState({ modalKey: 'tip' });
               setModalState({ ...data, extraInfo: null });
            }, 800)
         } else {
            setSendModalState({ modalKey: 'tip' });
            setModalState({ ...data, extraInfo: null });
         }
      } else {
         const { onCloseSendModal, screenWidth } = this.props;
         window.wallet_referrer_url = null
         this.setState({ animateSend: 'down' });
         if(screenWidth < 701){
            this.timerFetching = setTimeout(() => {
               // setModalState({ 'isTipModal': false });
               onCloseSendModal(false);
            }, 800)
         } else {
            // setModalState({ 'isTipModal': false });
            onCloseSendModal(false);
         }
      }
   }

   onTipMeModalClose = (data) => {
      QueryParams.removeQueryParam('open-top-up');
      QueryParams.removeQueryParam('modal-key');
      const { setModalState, setSendModalState, screenWidth } = this.props;
      this.setState({ animateLimit: 'down' });
      if(screenWidth < 701) {
         this.timerFetching = setTimeout(() => {
            setSendModalState({ modalKey: 'tip' });
            setModalState(data);
         }, 800)
      } else {
         setSendModalState({ modalKey: 'tip' });
         setModalState(data);
      }
   }

   topUpMyWallet = () => {
      const { initWallet } = this.props;
      this.setState({ type: 'top_up' });
      const { referrerUrl } = this.props
      window.wallet_referrer_url = referrerUrl
      initWallet()
   }

   goToWalletTopUp = (type) => {
      const { setSendModalState, setModalState, getWalletBalance } = this.props;
      getWalletBalance();
      setTimeout(() => {
         setSendModalState({ isOpenSendModal: false, isSend: false, isNotEnoughtBalance: false, modalKey: 'top_up' });
         setModalState({ 'isTipModal': true });
      }, 100)
      this.topUpMyWallet();
   }

   onSend = async (type, message) => {
      const {
         setSendModalState,
         sendRequest,
         sendCompleted,
         sendFailed,
         initWalletPaymentHistory,
         updateWalletBalanc,
         locationPath,
         updateMassMessageAfterPayment,
         // initStoreById,
         paymentType,
         // goTo,
         isFakeUser,
         unlockType,

         contentData,
         extraInfo,
         videoType,
         actionAfterPayment,
         purchaseData,
         setUpdatePurchaseMeda,
         pageType,
      } = this.props;
      let data = {
         id: this.id,
         type: this.type,
      }
      setSendModalState({ isFetching: true });
      let isUnavailableLivestreamPurchase = false;
      if('livestream' ===  this.type){
         const response = await initLiveStream();
         isUnavailableLivestreamPurchase = onUnavailableLivestreamPurchase(response.data, this.id)
      }
      if(isUnavailableLivestreamPurchase){
         this.clearModalState();
         return;
      }

      if(['chat_text_message', 'chat_voice_message', 'chat_photo_message'].includes(this.type)) {
         data = {
            type: this.type,
         }
      }
      if(isFakeUser){
         toast.info('Payments are disabled in preview mode');
      } else {
         if(paymentType === 'download_content') {
            data = {
               ...data,
               type: `${ this.type }_download`,
            }
         }
         if(unlockType && (this.props.type !== 'mass_message' || this.props.type !== 'private_mass_message')) {
            data = {
               ...data,
               unlock_type: unlockType,
            }
         }

         sendRequest()
         setUpdatePurchaseMeda({})
         const sendData = { ...data }
         if(data.type.includes('unlock')) {
            sendData.type = `chat_${ data.type }`;
         }
         switch (data.type) {
            case 'photo_unlock':
            case 'video_unlock':
            case 'voice_unlock':
               sendData.type = `chat_${ data.type }`;
               break;
            case 'photoset':
            case 'video':
               sendData.type = `${ data.type }_unlock`;
               if('video' === data.type && 'livestream' === videoType){
                  sendData.extra_info = {
                     video_type: 'livestream',
                  }
               }
               break;
            case 'livestream':
               sendData.type = `live_stream_unlock`;
               break;
            case 'tip':
               sendData.type = data.type;
               if(extraInfo && 'live_stream' === extraInfo.tip_type){
                  sendData.extra_info = extraInfo;
               }
               break;
            case 'store':
               if(!!purchaseData?.purchase_type) {
                  sendData.type = purchaseData.purchase_type
               }
               break
            default:
               break;
         }

         try {
            let finalRespons = {}
            if('wallet' === type) {
               if(contentData.resource_id && contentData.resource_type) {
                  sendData.resource_id = contentData.resource_id
                  sendData.resource_type = contentData.resource_type
               }
               if(contentData.message) {
                  sendData.note = contentData.message
               }

               if(!!purchaseData){
                  const { is_order_request, shipping_fee_detail_id, duration, price, note, count, questions, extras, option, order_request_payment_id, is_custom_form, param } = purchaseData
                  sendData.price = price
                  sendData.note = note
                  sendData.extras = extras
                  sendData.option = option
                  sendData.urlParams = param
                  sendData.is_order_request = is_order_request
                  sendData.is_custom_form = is_custom_form

                  if(order_request_payment_id) {
                     sendData.order_request_payment_id = order_request_payment_id
                  }

                  if(!!count){
                     sendData.count = count
                     sendData.shipping_fee_detail_id = shipping_fee_detail_id
                  }
                  if(!!duration) {
                     sendData.duration = duration
                  }
                  if(!!is_custom_form) {
                     sendData.questions = questions
                  }

               }

               // const affiliateId = LocalStorage.getItem('affiliateId')
               // if(affiliateId) {
               //    if(sendData?.extra_info) {
               //       sendData.extra_info = {
               //          ...sendData?.extra_info,
               //          affiliate_id: affiliateId,
               //       }
               //    } else  {
               //       sendData.extra_info = {
               //          affiliate_id: affiliateId,
               //       }
               //    }
               // }

               if(!!purchaseData?.is_order_request && pageType !== 'order-details') {
                  if(actionAfterPayment) {
                     actionAfterPayment({ purchaseData, type })
                  }
                  return
               }

               const responseData = await paymentPurchaseUsingWallet(sendData);
               finalRespons = responseData.data

               if(responseData.status === 200 && responseData.data && responseData.data.data && responseData.data.data.wallet_balance) {
                  updateWalletBalanc({ ...responseData.data.data, id: this.id });
                  setUpdateMethods({
                     wallet: {
                        balance: responseData.data.data,
                     },
                  })
                  const { siteInfo } = this.props;
                  // Send Purchase Data via GTM Data Layer
                  const payloadData = responseData.data?.data || {};
                  const ecommerce = {
                     transaction_id: payloadData?.transaction_id,
                     amount: payloadData.amount,
                     shipping: 0,
                     id: payloadData.id,
                     item_name: payloadData?.name || payloadData?.item_name,
                     purchase_type: payloadData.purchase_type,
                  }
                  sendGoogleAnalyticsPurchaseEvent(siteInfo, ecommerce);
               }
            }
            let modal = {
               // isOpenSendModal: false,
               isSend: false,
               isNotEnoughtBalance: false,
            };
            let isPayed = 'wallet' === type;
            let transacationId = null;
            if('one_click' === type) {
               const oneClick =  this.getOnClickData();

               if(contentData?.resource_id && contentData?.resource_type) {
                  oneClick.resource_id = contentData.resource_id
                  oneClick.resource_type = contentData.resource_type
               }
               if(contentData?.message) {
                  oneClick.note = contentData.message
               }
               if(!!purchaseData){
                  const { is_order_request, shipping_fee_detail_id, duration, price, note, count, questions, extras, option, order_request_payment_id, is_custom_form, param } = purchaseData

                  oneClick.price = price
                  oneClick.note = note
                  oneClick.extras = extras
                  oneClick.option = option
                  oneClick.urlParams = param
                  oneClick.is_order_request = is_order_request
                  oneClick.is_custom_form = is_custom_form

                  if(order_request_payment_id) {
                     oneClick.order_request_payment_id = order_request_payment_id
                  }

                  if(!!count){
                     oneClick.count = count
                     oneClick.shipping_fee_detail_id = shipping_fee_detail_id
                  }

                  if(!!duration) {
                     oneClick.duration = duration
                  }

                  if(!!is_custom_form) {
                     oneClick.questions = questions
                  }
               }

               // const affiliateId = LocalStorage.getItem('affiliateId')

               // if(affiliateId) {
               //    if(oneClick?.extra_info) {
               //       oneClick.extra_info = {
               //          ...oneClick?.extra_info,
               //          affiliate_id: affiliateId,
               //       }
               //    } else  {
               //       oneClick.extra_info = {
               //          affiliate_id: affiliateId,
               //       }
               //    }
               // }

               if(!!purchaseData?.is_order_request && !['order-details', 'all'].includes(pageType) && !purchaseData?.isRetryPayment) {
                  if(actionAfterPayment) {
                     actionAfterPayment({ purchaseData, type })
                  }
                  return
               }

               const { data } =  await oneClickPurchase(oneClick);
               finalRespons = data
               const { siteInfo } = this.props;
               const code = siteInfo?.tracking_code?.payment_success_page
               if(code && 'membership' ===  data.type){
                  addDynamicCode(code, 'body');
               }
               isPayed = !!data.success
               transacationId = data.transacationId
               if(isPayed){
                  // Send Purchase Data via GTM Data Layer
                  const ecommerce = {
                     transaction_id: transacationId,
                     amount: data.amount,
                     shipping: 0,
                     id: data.id,
                     item_name: data?.name || data?.item_name,
                     purchase_type: data.purchase_type,
                  }
                  sendGoogleAnalyticsPurchaseEvent(siteInfo, ecommerce);
               }
               modal = {
                  ...modal,
                  oneClickInfo: {
                     isDeclined: !data.success,
                     reason: data.message,
                     type: this.type,
                  },
                  isFetching: false,
                  isOpenChoosePaymentModal: false,
               }
            }
            setSendModalState(modal)

            // if(modal.oneClickInfo?.isDeclined) return
            sendCompleted(data);
            if(isPayed) {
               if('one_click' === type && data.type === 'wallet') {
                  try {
                     const { data } = await getWalletBalanceApi()
                     const { updateWalletBalanc } = this.props;
                     updateWalletBalanc({ ...data, transacationId })
                  } catch (error) {

                  }

               }
               if(!!Router.route('WALLET').match(locationPath)){
                  initWalletPaymentHistory();
               }
               if((data.type === 'video' || data.type === 'video_download')) {
                  if('one_click' === type
                  || !!Router.route('VIDEOS_INDIVIDUAL').match(locationPath)
                  || !!Router.route('VIDEOS').match(locationPath)
                  || !!Router.route('HOMEPAGE').match(locationPath)
                  || !!Router.route('LIVE_STREAM_RECORDS_STREAM').match(locationPath)
                  || !!Router.route('LIVE_STREAM_RECORD').match(locationPath)
                  ){
                     try {
                        let apiQuery = '';
                        if(videoType) {
                           apiQuery = `?video_type=${ videoType }`
                        }
                        const  { data } = await getVideoById(this.id, apiQuery)
                        const { fetchVideoByIdCompleted, updateVideoById, updateMediaItem, updateRecordoById, updateVideoDataAfterPurchase, updateRecordsDataAfterPurchase } = this.props;
                        this.setMedia({ ...data, transacationId });
                        if(!!Router.route('VIDEOS_INDIVIDUAL').match(locationPath)) {
                           fetchVideoByIdCompleted(data);
                           updateVideoDataAfterPurchase(data)
                        }
                        if(!!Router.route('VIDEOS').match(locationPath)) {
                           updateVideoById(data, this.id);
                        }
                        if(!!Router.route('LIVE_STREAM_RECORD').match(locationPath)) {
                           fetchVideoByIdCompleted(data);
                           updateRecordsDataAfterPurchase(data)
                        }
                        if(!!Router.route('LIVE_STREAM_RECORDS_STREAM').match(locationPath)) {
                           updateRecordoById(data, this.id);
                        }
                        if(!!Router.route('HOMEPAGE').match(locationPath)) {
                           let hompageContentType = 'videos';
                           if('livestream' === videoType){
                              hompageContentType = 'recordedStreams'
                           }
                           updateMediaItem(hompageContentType, data);
                        }
                     } catch (error) {

                     }
                  }
               }
               if((data.type === 'photoset' || data.type === 'photoset_download')) {
                  if('one_click' === type
                  || !!Router.route('PHOTOSETS_INDIVIDUAL').match(locationPath)
                  || !!Router.route('PHOTOSETS').match(locationPath) || !!Router.route('HOMEPAGE').match(locationPath)){
                     try {
                        const  { data } = await getPhotosetById(this.id);
                        const { fetchPhotosetByIdCompleted, updatePhotosetById, updateMediaItem, updatePhotosetDataAfterPurchase } = this.props;
                        this.setMedia({ ...data, transacationId });
                        if(!!Router.route('PHOTOSETS_INDIVIDUAL').match(locationPath)) {
                           fetchPhotosetByIdCompleted(data);
                           updatePhotosetDataAfterPurchase(data)
                        }
                        if(!!Router.route('PHOTOSETS').match(locationPath)) {
                           updatePhotosetById(data, this.id);
                        }
                        if(!!Router.route('HOMEPAGE').match(locationPath)) {
                           updateMediaItem('photosets', data);
                        }
                     } catch (error) {

                     }
                  }
               }
               if(data.type === 'store') {
                  if('one_click' === type || !!Router.route('STORE_DETAILS').match(locationPath) || !!Router.route('STORE').match(locationPath)){
                     try {
                        const { fetchStoreById } = this.props;
                        fetchStoreById(this.id, (data) => {
                           this.setMedia({ ...data, transacationId });
                        }, true);
                     } catch (error) {

                     }
                  }

               }
               if('one_click' === type  && ['mass_message', 'photo_unlock', 'video_unlock', 'voice_unlock', 'private_mass_message', 'multiple_attachment'].includes(data.type)) {
                  try {
                     const  { data } = await getChatUnlcokedItem(this.id);
                     this.setMedia({ ...data, transacationId });

                  } catch (error) {

                  }
               }
               if('livestream' === data.type) {
                  try {
                     const { initLiveStream } = this.props;
                     initLiveStream();
                     this.setMedia({ transacationId });

                  } catch (error) {

                  }
               }
            }
            if(updateMassMessageAfterPayment) {
               updateMassMessageAfterPayment(type)
            }
            if(actionAfterPayment) {
               actionAfterPayment({ purchaseData, type, finalRespons })
            }
         } catch (error) {
            if(error && error.response) {
               const errorData = error.response.data
               sendFailed({ ...errorData, payment_type: sendData.type }, { ...data });
               if(errorData.data && 'wallet_balance' in errorData.data) {
                  updateWalletBalanc(errorData.data);
               }
            }
         }
      }
   }
   getOnClickData = () => {

      const { paymentType, extraInfo, videoType } = this.props

      console.log('getOnClickData', {
         paymentType, extraInfo, videoType,
      });

      let result = {};
      result.id = this.id;
      switch (this.type) {
         case 'video':
            result.type = 'video_unlock';
            if('download_content' === paymentType) {
               result.type = 'video_download';

            }
            if('livestream' === videoType) {
               result.extra_info = {
                  video_type: 'livestream',
               }
            }
            break;
         case 'photoset':
            result.type = 'photoset_unlock';
            if('download_content' === paymentType) {
               result.type = 'photoset_download';

            }
            break;
         case 'wallet':
            result.type = 'wallet_top_up';
            const { isAddProcessingFees } = this.props
            result = {
               ...result,
               extra_info: {
                  add_processing_fees_to_my_top_up_amount: isAddProcessingFees,
               },
            }
            break;
         case 'photo_unlock':
         case 'video_unlock':
         case 'voice_unlock':
            result.type = `chat_${ this.type }`;
            break;
         case 'chat_photo_message':
         case 'chat_text_message':
         case 'chat_voice_message':
            result.extra_info = extraInfo;
            result.type = this.type;
            break;
         case 'livestream':
            result.type = `live_stream_unlock`;
            break;
         case 'tip':
            result.type = this.type;
            if(extraInfo && 'live_stream' === extraInfo.tip_type){
               result.extra_info = extraInfo
            }
            break;
         default:
            result.type = this.type
            break;
      }

      return result
   }

   onDownload = () => {
      const { onDownload } = this.props;
      this.onCloseSendModal()
      let type = this.type;
      if(this.type === 'photoset') {
         type = 'photosets';
      }
      if(this.type === 'video') {
         type = 'videos'
      }
      onDownload(this.id, type)
   }

   onContinue = async (type) => {
      const {
         setSendModalState,
         usdTerms,
         updateWalletBalanceStart,
         updateWalletBalanc,
         updateWalletBalanceFailed,
         // purchaseData,
         // actionAfterPayment,
         // pageType,
      } = this.props;
      if(type === 'wallet') {
         this.setState({ isSendTip: true })
         updateWalletBalanceStart();

         // if(!!purchaseData && !!purchaseData?.is_order_request && !['order-details', 'all'].includes(pageType) && !purchaseData?.isRetryPayment) {
         //    await actionAfterPayment({ purchaseData, type })
         //    this.setState({ isSendTip: false })
         //    updateWalletBalanceFailed()
         //    return
         // }


         try {
            const { data } = await getWalletBalance();
            updateWalletBalanc(data);
            // if(!!purchaseData && !!purchaseData?.is_order_request && !['order-details', 'all'].includes(pageType)) {
            //    if(usdTerms > data.wallet_balance) {
            //       setSendModalState({ isNotEnoughtBalance: true, isOpenChoosePaymentModal: false,  isOpenSendModal: true, paymentError: null });
            //    } else if(actionAfterPayment && usdTerms < data.wallet_balance) {
            //       await actionAfterPayment({ purchaseData, type })
            //    }
            //    this.setState({ isSendTip: false })
            //    updateWalletBalanceFailed()
            //    return
            // }
            this.setState({ isSendTip: false });
            if(usdTerms > data.wallet_balance) {
               setSendModalState({ isNotEnoughtBalance: true, isOpenChoosePaymentModal: false,  isOpenSendModal: true, paymentError: null });
            } else {
               setSendModalState({ isOpenChoosePaymentModal: false, isOpenSendModal: true, paymentError: null });
            }
         } catch {
            this.setState({ isSendTip: false })
            updateWalletBalanceFailed()
         }
      }
      if(type === 'other') {
         this.chooseAnotherPayment();
      }
      if(type === 'paypal') {
         console.log('This payment method supported only Frisky Business');
      }
   }

   onCloseChoosePaymentModal = (bool) => {
      const { setSendModalState } = this.props;
      setSendModalState({ isOpenChoosePaymentModal: bool });
   }

   chooseAnotherPayment = () => {
      const { goTo, id, type, setSendModalState, setModalState, isAddProcessingFees, paymentType, unlockType, extraInfo, videoType, contentData, purchaseData, updateCallBackAfterRedirectPayment, openChargeModal } = this.props;
      console.log({
         type,
         paymentType,
         unlockType,
      });
      let path = '';
      switch (type) {
         case 'photoset':
            path = 'PURCHASE_PHOTOSET';
            break;
         case 'video':
            path = 'PURCHASE_VIDEO';
            if('unlock_content' === paymentType && 'livestream' === videoType){
               path = 'PURCHASE_LIVE_STREAM_RECORDS';
            }
            break;
         case 'tip':
            path = 'PURCHASE_TIP';
            break;
         case 'video_unlock':
            path = 'PURCHASE_VIDEO_UNLOCK';
            break;
         case 'photo_unlock':
            path = 'PURCHASE_PHOTO_UNLOCK';
            break;
         case 'voice_unlock':
            path = 'PURCHASE_VOICE_UNLOCK';
            break;
         case 'store':
            path = 'PURCHASE_STORE';
            break;
         case 'wallet':
            path = 'PURCHASE_WALLET';
            break;
         case 'livestream':
            path = 'PURCHASE_LIVE_STREAM';
            break;
         case 'mass_message':
         case 'private_mass_message':
            if(unlockType === 'photo_unlock') {
               path = 'PURCHASE_PHOTO_UNLOCK';
            }
            if(unlockType === 'video_unlock') {
               path = 'PURCHASE_VIDEO_UNLOCK';
            }
            if(unlockType === 'multiple_attachment') {
               path = 'PURCHASE_MULTIPLE_ATTACHMENT';
            }
            break;
         case 'chat_text_message':
         case 'chat_photo_message':
         case 'chat_voice_message':
            path = 'PURCHASE_CHAT_PAY_PER_MESSAGE';
            break;
         case 'multiple_attachment':
            path = 'PURCHASE_MULTIPLE_ATTACHMENT';
            break;
         default :
            path = '';
            break;
      }
      setModalState({ isTipModal: false });
      setSendModalState({ isOpenChoosePaymentModal: false, isOpenSendModal: false, modalKey: 'tip', modalType: 'tip' });
      if(path){
         let param = '';
         if(['voice_unlock', 'video_unlock', 'photo_unlock'].includes(type)) {
            param = `type=${ type }`;
         }
         if(type === 'wallet') {
            param = `add_processing_fees_to_my_top_up_amount=${ isAddProcessingFees }`
         }
         if(type === 'photoset' || type === 'video') {
            param = `payment_type=${ paymentType || 'unlock_content' }`;
            if('unlock_content' === paymentType && 'livestream' === videoType){
               param = `${ param }&video_type=livestream`;
            }
         }
         if((type === 'mass_message' || type === 'private_mass_message') && !!unlockType) {
            param = `type=${ unlockType }`;
         }
         if(type === 'tip' && !!extraInfo) {
            param = `type=${ extraInfo.tip_type }`;
            if(extraInfo.tip_action){
               const action = encodeURIComponent(JSON.stringify(extraInfo.tip_action));
               param = `${ param }&action=${ action }`
            }
         }
         if(type === 'tip' && contentData.resource_id && contentData.resource_type) {
            param = `resource_id=${ contentData.resource_id }&resource_type=${ contentData.resource_type }`
         }
         if(type === 'tip' && contentData.message) {
            if(param.length > 1) {
               param += `&note=${ contentData.message }`
            }
            if(param.length === 0) {
               param += `note=${ contentData.message }`

            }
            const { closeChat } = this.props
            if(closeChat) {
               closeChat()
            }
         }
         if(type === 'store' && purchaseData !== null) {
            param = purchaseData?.param
         }

         if(['multiple_attachment'].includes(type)) {
            param = `type=${ type }`;
         }

         if(updateCallBackAfterRedirectPayment){
            updateCallBackAfterRedirectPayment(purchaseData)
            if(!!openChargeModal) {
               return
            }
         }
         if(['chat_text_message', 'chat_voice_message', 'chat_photo_message'].includes(type)){
            param += `extraInfo=${ encodeURIComponent(JSON.stringify(extraInfo)) }`
            goTo(Router.route(path).getCompiledPath({ id: type }), param);
         } else {
            goTo(Router.route(path).getCompiledPath({ id }), param);
         }

      }
   }

   goToMedia = (url) => {
      const { goTo, closeChat } = this.props;
      if(closeChat) {
         closeChat()
      }
      this.onCloseSendModal();
      goTo(url);
   }

   setMedia = (media) => {
      let data = {}
      let type = this.type;
      console.log({ media });

      if(type === 'mass_message' || type === 'private_mass_message'){
         type = media.type
         data.type = type
      }

      if('content_type' in media && media?.content_type === 'multiple_attachment'){
         type = media?.content_type
         data.type = type
      }

      const { setUpdatePurchaseMeda } = this.props
      switch (type) {
         case 'video':
         case 'video_download':
         case 'video_unlock':
            data = {
               ...data,
               poster_src: media.poster_src,
               duration: media.duration,
               hls_manifest: media.hls_manifest,
               id: media.id,
            }
            break;
         case 'photoset':
         case 'photoset_download':
            data = {
               photos: [media.cover_photo],
               photos_count: media.photos_count,
               id: media.id,
            }
            break;
         case 'photo_unlock':
            data = {
               ...data,
               photos: media.photos,
               photos_count: media.count,
               id: media.id,
            }
            break;
         case 'store':
            data = {
               poster_src: media.src,
               id: media.id,
            }
            break;
         case 'voice_unlock':
            data = {
               src: media.src,
               duration: media.duration,
            }
            break;
         case 'multiple_attachment':
            data = {
               src: media.src,
               count: media?.count,
            }
            break;

         default:
            break;
      }
      if(media?.transacationId) {
         data = {
            ...data,
            transacationId: media.transacationId,
         }
      }

      console.log('data for setUpdatePurchaseMeda', { data });

      setUpdatePurchaseMeda(data)
   }

   //share and copy content modal
   onShare = (id, type) => {
      this.setState((prev) => {
         return {
            ...prev,
            shareableItemId: id,
            shareableItemType: type,
         }
      })
   }

   handleCloseModal = () => {
      this.setState((prev) => {
         return {
            ...prev,
            showLinks: !this.state.showLinks,
         }
      })
   }

   onClickCopy = (id, type) => {
      let text = window.location.host
      if(type === 'video'){
         text = `${ window.location.host }${ Router.route('VIDEOS_INDIVIDUAL').getCompiledPath({ id }) }`
      }
      if(type === 'photoset'){
         text = `${ window.location.host }${ Router.route('PHOTOSETS_INDIVIDUAL').getCompiledPath({ id }) }`
      }
      if(type === 'story'){
         text = `${ window.location.host }${ Router.route('STORIES_SHOW').getCompiledPath({ id }) }`
      }
      if(type === 'store'){
         text = `${ window.location.host }${ Router.route('STORE_DETAILS').getCompiledPath({ id }) }`
      }
      if(type === 'livestream'){
         text = `${ window.location.host }${ Router.route('LIVE_STREAM_RECORD').getCompiledPath({ id }) }`
      }
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      toast.info('Sharing link has been copied');
   }

   onChangeFavoriteItem = (id, type, callback) => {
      const { onChangeFavoriteItem } = this.props

      try {
         onChangeFavoriteItem(id, type, () => {
            if(callback) callback()
         })
         // console.log(id, type);

      } catch (error) {

      }
   }

   render() {
      const {
         isGoBack = false,
         id,
         screenWidth,
         siteInfo,
         authUser,
         isSend,
         isFetchingSend,
         isFetching,
         isNotEnoughtBalance,
         usdTerms,
         isOpenChoosePaymentModal,
         type,
         modalType,
         isFetchingJoin,
         walletBalance,
         isFetchingBalance,
         mediaName,
         tipModalData,
         isCheckLimitFetching,
         locationPath,
         methods,
         oneClickInfo,
         mediaData,
         unlockType,
         paymentError,
         setSendModalState,
         onlyWalletPay,
         paymentSend,
         contentData,
         chatPanel,
         videoType,
         extraInfo,
         purchaseData,
         onCloseSuccessModal,
         isFetchingModal,
         pageType,
         isChat,
         paymentType,
      } = this.props;

      const contentType = 'mass_message' ===  this.type || 'private_mass_message' ===  this.type ? unlockType : this.type
      const { animateSend, height, isSendTip, animateLimit, showLinks, shareableItemId, shareableItemType } = this.state
      if(isFetching){
         return <PageLoader customStyle='h-full w-full my-10' withLoader loaderColor='primary' />
      }

      return (
         <>
            {
               (type === modalType) && (
                  <PurchaseMethodModal
                     isGoBack={ isGoBack && !isSend && !isNotEnoughtBalance }
                     onModalClose={ (e, isTip) => this.onCloseSendModal(false, isTip) }
                     goBack={ this.goBack }
                     selectedAmount={ this.type === 'tip' ? id : usdTerms }
                     isMobile={ type === 'store' ? screenWidth < 1025 : screenWidth < 701 }
                     height={ height }
                     balance={ walletBalance }
                     ownerAvatar={ siteInfo.admin_avatar }
                     ownername={ siteInfo.admin_screen_name }
                     onSend={ (tip, message) => this.onSend(tip, message) }
                     isSend={ isSend }
                     type={ contentType }
                     isDisabled={ isFetchingSend || isFetchingJoin }
                     isCheckLimitFetching={ isCheckLimitFetching }
                     isFetchingBalance={ isSendTip && isFetchingBalance }
                     isNotEnoughtBalance={ isNotEnoughtBalance }
                     goToWalletTopUp={ () => this.goToWalletTopUp('top_up') }
                     onDownload={ this.onDownload }
                     isOpenChoosePaymentModal={ isOpenChoosePaymentModal }
                     onContinue={ this.onContinue }
                     savedPaymentMethod={ authUser && authUser.saved_payment_method }
                     animate={ animateSend }
                     mediaName={ mediaName }
                     mediaData={ mediaData }
                     goToMedia={ this.goToMedia }
                     locationPath={ locationPath }
                     methods={ methods }
                     oneClickInfo={ oneClickInfo }
                     paymentError={ paymentError }
                     clearErrorState={ () => setSendModalState({ modalType: '', paymentError: null }) }
                     onlyWalletPay={ onlyWalletPay }
                     paymentSend={ paymentSend }
                     contentData={ contentData }
                     chatPanel={ chatPanel }
                     videoType={ videoType }
                     extraInfo={ extraInfo }
                     purchaseData={ purchaseData }
                     isFetchingModal={ isFetchingModal }
                     onCloseSuccessModal={ onCloseSuccessModal }
                     siteInfo={ siteInfo }
                     onShare={ (id, type) => {
                        this.onShare(id, type)
                        this.handleCloseModal()
                     } }
                     pageType={ pageType }
                     onChangeFavoriteItem={ this.onChangeFavoriteItem }
                     isChat={ isChat }
                     isDownloadPurchase={ 'download_content' === paymentType }
                  />
               )
            }
            {
               tipModalData.isLimitModal && (
                  <LimitModal
                     title={ tipModalData.header }
                     description={ tipModalData.body }
                     onCancel={ () => this.onTipMeModalClose({ isLimitModal: false }) }
                     isMobile={ screenWidth < 701 }
                     animate={ animateLimit }
                  />
               )
            }
            {
               showLinks && <Modal
                  contentPosition={ screenWidth < 430  ? 'bottom' : 'center' }
                  onClose={ () => this.handleCloseModal() }
                  otherclassName='h-84 overflow-hidden'
                  contentWidth={ screenWidth < 430  ? '100%' : '348px' }
               >
                  <SocialMediaLinks
                     onClick={ () => this.handleCloseModal() }
                     onCopy={ () => this.onClickCopy(shareableItemId, shareableItemType) }
                     id={ shareableItemId }
                     type={ shareableItemType }
                     isGlobalRoute={ true }
                  />
               </Modal>
            }
         </>
      )
   }
}
const mapStatesToProps = state => ({
   authUser: authUserSelector(state),
   screenWidth: screenWidthSelector(state),
   siteInfo: siteInfoSelector(state),
   isFetching: isFetchingSelector(state),
   isNotEnoughtBalance: isNotEnoughtBalanceSelector(state),
   isSend: isSendSelector(state),
   isFetchingSend: isFetchingSendSelector(state),
   isFetchingJoin: isFetchingJoinSelector(state),
   isOpenSendModal: isOpenSendModalSelector(state),
   isOpenChoosePaymentModal: isOpenChoosePaymentModalSelector(state),
   modalType: modalTypeSelector(state),
   modalKey: modalKeySelector(state),
   walletBalance: walletBalanceSelector(state),
   isFetchingBalance: isFetchingBalanceSelector(state),
   tipModalData: tipModalDataSelector(state),
   isCheckLimitFetching: isCheckLimitFetchingSelector(state),
   locationPath: currentLocationPathSelector(state),
   mediaData: walletMediaDataSelector(state),
   methods: methodsSelector(state),
   isFakeUser: isFakeUserSelector(state),
   oneClickInfo: oneClickInfoSelector(state),
   paymentError: paymentErrorSelector(state),
   onlyWalletPay: onlyWalletPaySelector(state),
   contentData: contentDataSelector(state),
   chatPanel: chatPanelSelector(state),
   purchaseData: purchaseDataSelector(state),
   isFetchingModal: isFetchingModalSelector(state),
   pageType: pageTypeSelector(state),
});

const mapDispatchToProps = dispatch => ({
   paymentSend: (data) => dispatch(paymentSend(data)),
   initWallet: () => dispatch(initWalletOperation()),
   setSendModalState: (data) => { dispatch(setSendModalState(data)) },
   setModalState: (data) => { dispatch(setModalState(data)) },
   onDownload: (id, type) => dispatch(downloadMediaOperation(id, type)),
   onClickPayment: (data) => dispatch(purchaseOptions(data)),
   updateWalletBalanceStart: () => { dispatch(updateWalletBalanceStart()) },
   updateWalletBalanc: (data) => { dispatch(updateWalletBalanc(data)) },
   updateWalletBalanceFailed: () => { dispatch(updateWalletBalanceFailed()) },
   getWalletBalance: () => { dispatch(getWalletBalanceOperation()) },
   sendRequest: () => { dispatch(sendRequest()) },
   sendCompleted: (data, modalData) => { dispatch(sendCompleted(data, modalData)) },
   sendFailed: (error, data) => { dispatch(sendFailed(error, data)) },
   initWalletPaymentHistory: (params) => { dispatch(initWalletPaymentHistoryOperation(params)) },
   setUpdateMethods: data =>  dispatch(setUpdateMethods(data)),
   goTo: (path, search) => {
      dispatch(push({
         pathname: path,
         search,
      }))
   },
   setUpdatePurchaseMeda: data => dispatch(setUpdatePurchaseMeda(data)),
   fetchPhotosetByIdCompleted: id => dispatch(fetchPhotosetByIdCompleted(id)),
   updatePhotosetById: (data, id) => dispatch(updatePhotosetById(data, id)),
   fetchVideoByIdCompleted: id => dispatch(fetchVideoByIdCompleted(id)),
   updateVideoById: (id, data) => dispatch(updateVideoById(id, data)),
   fetchStoreById: (id, callback, bool) => dispatch(initStoreByIdOperation(id, callback, bool)),
   updateMediaItem: (type, data) => dispatch(updateMediaItemInHompageAction(type, data)),
   initLiveStream: () => dispatch(initLiveStreamOperation(false)),
   updateRecordoById: (data, id) => dispatch(updateRecordoByIdAction(data, id)),
   updatePhotosetDataAfterPurchase: (data) => dispatch(updatePhotosetDataAfterPurchaseOperation(data)),
   updateVideoDataAfterPurchase: (data) => dispatch(updateVideoDataAfterPurchaseOperation(data)),
   updateRecordsDataAfterPurchase: (data) => dispatch(updateRecordsDataAfterPurchaseOperation(data)),
   onChangeFavoriteItem: (id, type, successCallBack) => dispatch(onChangeFavoriteItemOperation(id, type, false, true, successCallBack)),
})
export default connect(mapStatesToProps, mapDispatchToProps)(PurchaseTipContaine);
